import { render } from "./DiscountVatReport.vue?vue&type=template&id=46c7e18a&scoped=true"
import script from "./DiscountVatReport.vue?vue&type=script&lang=js"
export * from "./DiscountVatReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=46c7e18a&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c7e18a"]])

export default __exports__